<div style="text-align: center;"><img #imageDisplay id="image-display-id" src="{{src}}"></div>
{{getStyles(imageDisplay)}}